import { ApiError } from "./http-client";

/**
 * The machine-readable `errorCode` of an API error envelope, or null when the
 * error is not an `ApiError` or carries no usable code. Feature resolvers map
 * the code to their own copy; the raw body is never shown to the user.
 */
export function errorCodeOf(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  const body = err.body;
  if (!body || typeof body !== "object") return null;
  const code = (body as { errorCode?: unknown }).errorCode;
  return typeof code === "string" && code.length > 0 ? code : null;
}
